var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1223 9.00818H5.87769C5.51195 9.00818 5.21545 9.31576 5.21545 9.69517V19.3131C5.21545 19.6925 5.51195 20 5.87769 20H19.1223C19.4881 20 19.7846 19.6925 19.7846 19.3131V9.69517C19.7846 9.31576 19.4881 9.00818 19.1223 9.00818Z",
    fill: "#807F7D",
    stroke: "#807F7D",
    strokeWidth: 1.56098,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98782 11.0244V7.51219C8.98782 6.5807 9.35786 5.68736 10.0165 5.0287C10.6752 4.37003 11.5685 4 12.5 4C13.4315 4 14.3249 4.37003 14.9835 5.0287C15.6422 5.68736 16.0122 6.5807 16.0122 7.51219V11.0244",
    stroke: "#807F7D",
    strokeWidth: 1.56098,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8903 14.5041C12.8903 14.7196 12.7155 14.8943 12.5 14.8943C12.2845 14.8943 12.1098 14.7196 12.1098 14.5041M13.6707 14.5041C13.6707 15.1507 13.1466 15.6748 12.5 15.6748C11.8534 15.6748 11.3293 15.1507 11.3293 14.5041C11.3293 13.8575 11.8534 13.3334 12.5 13.3334C13.1466 13.3334 13.6707 13.8575 13.6707 14.5041Z",
    stroke: "#FFFDFA",
    strokeWidth: 1.56098,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.9c2cfe00362a9dc3914d342db1875da9.svg";
export { ForwardRef as ReactComponent };